let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gfsfz")).then(() => parcelRequire('3ZaVC'));